export const get_unread_messages_count = `query get_unread_messages_count{
    get_unread_messages_count
}`;
